import { render, staticRenderFns } from "./ConversationConfirmPage.vue?vue&type=template&id=380a7947&scoped=true"
import script from "./ConversationConfirmPage.vue?vue&type=script&lang=js"
export * from "./ConversationConfirmPage.vue?vue&type=script&lang=js"
import style0 from "./ConversationConfirmPage.vue?vue&type=style&index=0&id=380a7947&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380a7947",
  null
  
)

export default component.exports